import { motion } from 'framer-motion';
import { getLeagueConfig } from './league-tokens';
import { cn } from '../ui/utils';

const SIZE_MAP = {
  xs: { box: 'h-9 w-9', scale: '' },
  sm: { box: 'h-12 w-12', scale: '' },
  md: { box: 'h-16 w-16', scale: '' },
  lg: { box: 'h-24 w-24', scale: '' },
  xl: { box: 'h-32 w-32', scale: '' },
  fill: { box: 'h-full w-full', scale: '' },
};

export function LeagueBadge({ liga, size = 'md', animate = false, className, dimmed = false }) {
  const cfg = getLeagueConfig(liga);
  const sz = SIZE_MAP[size] || SIZE_MAP.md;

  const imgClass = cn(
    'shrink-0 select-none object-contain',
    sz.box,
    sz.scale,
    dimmed && 'opacity-40 saturate-50',
    className
  );

  if (animate) {
    return (
      <motion.img
        src={cfg.image}
        alt={cfg.name}
        title={cfg.name}
        draggable={false}
        className={imgClass}
        initial={{ scale: 0.6, opacity: 0, rotate: -12 }}
        animate={{ scale: 1, opacity: 1, rotate: 0 }}
        transition={{ type: 'spring', stiffness: 220, damping: 16 }}
      />
    );
  }

  return (
    <img
      src={cfg.image}
      alt={cfg.name}
      title={cfg.name}
      draggable={false}
      className={imgClass}
    />
  );
}

export default LeagueBadge;
